
import { Component, OnInit } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { RouterLink } from '@angular/router';
import { StaticWhyLoveComponent } from '../static-why-love/static-why-love.component';
@Component({
  selector: 'app-why-love-exam',
  imports: [
    CarouselModule,
    StaticWhyLoveComponent
  ], templateUrl: './why-love-exam.component.html',
  styleUrl: './why-love-exam.component.css'
})
export class WhyLoveExamComponent implements OnInit {




  responsiveOptions: any[] | undefined;

  subjects: any[] =
    [
      {
        name: 'Get better grades',
        icon: 'Icons/paper1.png',
        discrption: "Practice with targeted, exam-style questions that strengthen understanding and improve performance."
      },
      {
        name: 'Boost exam confidence',
        icon: 'Icons/paper3.png',
        discrption: "Regular practice helps you master question formats, reduce stress, and face every exam fully prepared."
      },

      {
        name: 'Learn from examiners',
        icon: 'Icons/exam3.png',
        discrption: "Our questions and solutions are crafted by expert teachers, giving you insider guidance and real exam insight."
      },




    ]


  ngOnInit(): void {
    this.responsiveOptions = [
      {
        breakpoint: '1400px',
        numVisible: 2,
        numScroll: 1
      },
      {
        breakpoint: '1199px',
        numVisible: 3,
        numScroll: 1
      },
      {
        breakpoint: '767px',
        numVisible: 2,
        numScroll: 1
      },
      {
        breakpoint: '575px',
        numVisible: 1,
        numScroll: 1
      }
    ]
  }

}
